import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import Wrapper from './style';
import Swal from 'sweetalert2';
import SearchDropdown from '../../../components/CustomDropdown/SearchDropdown';
import { searchUsers } from '../../../store/httpCalls';
import { hideLoader, showLoader } from '../../../utils/loader';
import { customBaseUrl, httpPost } from '../../../store/http';

const CreateAccount = ({ showModal, hideModal }) => {
  const [data, setData] = useState({});
  const [options, setOptions] = useState([]);
  const [query, setQuery] = useState('');

  const handleSearch = async (e) => {
    setQuery(e.target.value);
    if (e.target.value !== '') {
      const result = await searchUsers(e.target.value);
      setOptions(result);
    }
  };

  const handleSelectOption = (selectedUser) => {
    setData({ 
      ...data, 
      userId: selectedUser.userId, 
      fullName: `${selectedUser.firstName} ${selectedUser.surname}`
    });
    setQuery(`${selectedUser.firstName} ${selectedUser.surname}`);
    setOptions([]);
  };

  const handleSubmit = async () => {
    showLoader();

    const response = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/create-wallet`,
      data
    );
    
    hideLoader();
    if (response.status === true) {
      hideModal(false);
      Swal.fire('Success', 'Wallet Created Successfully', 'success');     
    } else {
      Swal.fire('Error', response.message, 'error');
    }
  };

  return (
    <Modal
      visible={showModal}
      closable={false}
      footer={null}
      centered
      onCancel={() => {
        hideModal(false);
      }}
      width='50%'
    >
      <Wrapper>
        <div className="cw-content">
          <h3>Create Account</h3>
          <div className='col-md-8'>
            <div className="input-content" style={{ marginTop: 30 }}>
              <div className="label2">Select User Type</div>
              <select 
                value={data.simulated || ''} 
                onChange={(e) => { setData({ ...data, simulated: e.target.value }) }} 
                className='label2 border border-dark'
              >
                <option value=''>Select User Type</option>
                <option value='true'>Simulated User</option>
                <option value='false'>Non Simulated User</option>
              </select>
            </div>
            <div className="input-content" style={{ marginTop: 30 }}>
              <div className="label2">Select Account Owner</div>
              <input
                type='text'
                className='form-control'
                id='validationCustom01'
                required
                value={query}
                onChange={handleSearch}
                placeholder='Search Account Owner'
              />
              <SearchDropdown options={options} handleClick={handleSelectOption} />
            </div>           
          </div>
        </div>
      </Wrapper>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '50px',
        }}
      >
        <Button
          style={{
            background: '#FF4B01',
            color: '#fff',
            fontSize: '14px',
            alignItems: 'center',
          }}
          onClick={handleSubmit}
        >
          Create Wallet
        </Button>
      </div>
    </Modal>
  );
};

CreateAccount.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default CreateAccount;
